import './contacts-filter.scss'
import {UserDto} from "../../../users/model/User";
import {UserFilter, UserView} from "../../../users/model/UserFilter";
import {UserService} from "../../../users_service/service/user.service";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {ToastNotificationServiceName, UserServiceName} from "../../../utils/names/serviceNames";
import {ContactFilter} from "../../../contact/model/ContactFilter";

export class ContactsFilterController {

    static instance = {
        template: require('./contacts-filter.html'),
        controller: [
            UserServiceName,
            ToastNotificationServiceName,
            ContactsFilterController
        ],
        bindings: {
            onSubmit: '<',
            filter: '='
        }
    }

    private filter: ContactFilter;
    private onSubmit: () => void;

    constructor(private userService: UserService,
                private toastNotificationService: ToastNotificationService) {
    }


    fetchEmployees = (query: string): angular.IPromise<UserDto[]> => {
        return this.userService.queryEmployee(this.getUserFilter(query))
            .then((resp) => {
                if (resp.status == 200) {
                    return resp.data;
                } else {
                    this.toastNotificationService.generateErrorMessage('Failed to fetch users')
                }
            })
    };

    private getUserFilter(query: string): UserFilter {
        return {
            branchesIds: [],
            showDeleted: false,
            showDisabled: true,
            userIds: [],
            query: query,
            view: UserView.AUTOCOMPLETE
        };
    }

    onEmployeeFilterValueChange = (employeeIds: number[]) => {
        this.filter.employeeIds = employeeIds;
    };


    checkForSubmit = ($event) => {
        if ($event.which === 13) {
            this.onSubmit();
        }
    };

}
